import { BaseAnalytics } from '@r1-frontend/analytics/dataLayerPush';

class ContextSurveyAnalytics extends BaseAnalytics {
    constructor(category = 'feedback_context') {
        super();

        this.category = category;
    }

    clickTakeSurvey() {
        this.send('open_survey_from_context');
    }

    closePopup() {
        this.send('close_popup');
    }
}

export default ContextSurveyAnalytics;
